<script setup lang="ts">
  import { ref } from 'vue';
  import { useAuthStore } from '@/stores/auth.ts';
  import { CompanyDto } from '@/services/api/company-api.ts';
  import { loadWithStatusAndErrorHandleAsync } from '@/services/loading-svc.ts';

  const authStore = useAuthStore();

  const loading = ref<boolean>(false);
  const selected = ref<string>();
  const companies = ref<CompanyDto[]>([]);

  loadWithStatusAndErrorHandleAsync(
    (status) => {
      loading.value = status;
    },
    async () => {
      await authStore.listCompanyByManagedMeAsync().then((items) => {
        companies.value = items;
        selected.value = authStore.user.companyCd;
      });
    }
  );

  function onChanged() {
    console.log('new: ' + selected.value);
    if (!selected.value) return;
    authStore.changeCompanyAsync(selected.value).then(() => {
      window.location.reload();
    });
  }
</script>

<template>
  <span
    v-if="loading"
    class="loading loading-ring loading-md mt-1 mr-10" />
  <div v-else>
    <h2
      v-if="companies.length == 1"
      class="mr-2 text-gray-500 text-md">
      {{ companies[0].name }}
    </h2>
    <select
      v-if="companies.length > 1"
      v-model="selected"
      class="select select-md select-ghost h-2 text-gray-500 text-md"
      style="font-size: 1rem"
      @change="onChanged">
      <option
        v-for="com in companies"
        :key="com.cd"
        :value="com.cd">
        {{ com.name }}
      </option>
    </select>
  </div>
</template>
